module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.toc !== null) ? _c('div', {
    staticClass: "component-create-plan"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Name")]), (_vm.$route.params.hasOwnProperty('id')) ? [_c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.toc._translatable.name,
      "label": "Name",
      "value": _vm.toc.name,
      "editable": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toc.name),
      expression: "toc.name"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.toc.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.toc, "name", $event.target.value)
      }
    }
  })])] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toc.name),
      expression: "toc.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.toc.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.toc, "name", $event.target.value)
      }
    }
  })]], 2), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Toc Type"), _c('selectize-toc-type', {
    attrs: {
      "selectedValue": _vm.toc.toc_type.id
    },
    on: {
      "optionSelected": _vm.setTocType
    }
  })], 1)]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Version"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toc.version),
      expression: "toc.version"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.toc.version)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.toc, "version", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Required from"), _c('DatePicker', {
    attrs: {
      "initialDate": _vm.toc.required_from
    },
    model: {
      value: (_vm.toc.required_from),
      callback: function($$v) {
        _vm.$set(_vm.toc, "required_from", $$v)
      },
      expression: "toc.required_from"
    }
  })], 1)]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Optional")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toc.optional),
      expression: "toc.optional"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.toc.optional) ? _vm._i(_vm.toc.optional, null) > -1 : (_vm.toc.optional)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.toc.optional,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.toc, "optional", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.toc, "optional", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.toc, "optional", $$c)
        }
      }
    }
  })]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Disabled")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toc.disabled),
      expression: "toc.disabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.toc.disabled) ? _vm._i(_vm.toc.disabled, null) > -1 : (_vm.toc.disabled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.toc.disabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.toc, "disabled", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.toc, "disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.toc, "disabled", $$c)
        }
      }
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Acceptance statement")]), (_vm.$route.params.hasOwnProperty('id')) ? [_c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.toc._translatable.acceptance_statement,
      "label": "Acceptance statement",
      "value": _vm.toc.acceptance_statement,
      "editable": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toc.acceptance_statement),
      expression: "toc.acceptance_statement"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.toc.acceptance_statement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.toc, "acceptance_statement", $event.target.value)
      }
    }
  })])] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toc.acceptance_statement),
      expression: "toc.acceptance_statement"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.toc.acceptance_statement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.toc, "acceptance_statement", $event.target.value)
      }
    }
  })], _c('label', [_vm._v("External url"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toc.link),
      expression: "toc.link"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.toc.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.toc, "link", $event.target.value)
      }
    }
  })])], 2), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Priority"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toc.priority),
      expression: "toc.priority"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.toc.priority)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.toc, "priority", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Attachment")]), _c('KeplerFileUpload', {
    attrs: {
      "selected-prefix": "tocs",
      "selected-visibility": "public",
      "preview-url": _vm.toc.attachment
    },
    on: {
      "sel": _vm.handleFileSelector
    }
  }), _c('TocAttachmentTranslationReveal', {
    staticClass: "mt-3",
    model: {
      value: (_vm.toc.attachment_translations),
      callback: function($$v) {
        _vm.$set(_vm.toc, "attachment_translations", $$v)
      },
      expression: "toc.attachment_translations"
    }
  })], 1)]), _vm._m(0), _c('div', {
    staticClass: "row columns"
  }, [(!_vm.$route.params.hasOwnProperty('id')) ? [_c('label', [_vm._v("Content")])] : [_c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.toc._translatable.content,
      "label": "Content",
      "value": _vm.toc.content,
      "editor": true,
      "editable": false
    }
  })], _c('Editor', {
    model: {
      value: (_vm.toc.content),
      callback: function($$v) {
        _vm.$set(_vm.toc, "content", $$v)
      },
      expression: "toc.content"
    }
  }), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.createToc
    }
  }, [_vm._v("Save")])], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ce22ad22!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CreateToc.vue
// module id = 2686
// module chunks = 1